
import React, { useRef, useContext, useEffect, useState, useMemo } from "react";
import classNames from 'classnames';

import { observer } from "mobx-react";

import Form from 'react-bootstrap/Form';

import Skeleton from 'react-loading-skeleton'
import { useTranslation } from "react-i18next";
import { Typeahead } from 'react-bootstrap-typeahead'; // ES2015
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Stack from 'react-bootstrap/Stack';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";


const FormSelect = (props) => {
    const { t } = useTranslation();
    const [value, setValue] = useState("");
    const [multiSelections, setMultiSelections] = useState([]);
    const isInvalid = () => multiSelections?.length == 0;
    
    const [field, setField] = useState([]);
    const isInputInvalid = () => props.validated && isInvalid();

    useEffect(() => {
        var value = props.object?.[props.id]?.toString();        
        var text = value && value != "" ? value : "";        

        updateVal(text);

        if (props.multiple) {
            var selection = text ? text.split(',') : null;
            if (selection?.length>0) {
                updateValues(selection)
            }
        }

    }, [props.object, props.multiple]);

    useEffect(() => {
        if (props.useVal)
            setValue(props.value);

    }, [props.value]);

    const updateVal = (v) => {
        setValue(v);
        if (props.observe) {props.observe(v)}
    }

    const updateValues = (e) => {
        setMultiSelections(e);
        setField(e);
        if (props.onChange) { props.onChange(e)}
    }

    return (
        /*AJUSTAR TODO PARA QUE LOS ITEMS SEAN ID/NAME*/
        <Form.Group controlId={props.id}>            
            {props.label ? <>{props.isLoading ? <Skeleton /> : <Form.Label>{props.label}</Form.Label>}</> : <span />}
            {props.isLoading && props.items ? <Skeleton height={30} /> :
                props.multiple ?
                    <Typeahead
                        placeholder={props.placeholder || t("enterValue")}
                        id={props.id}
                        multiple
                        onChange={updateValues}
                        options={props.items}
                        disabled={props.disabled}
                        selected={multiSelections}
                        isInvalid={isInputInvalid()}
                        isValid={multiSelections?.length > 0}                        
                    />
                    :
                    <Stack direction="horizontal" gap={2}>
                        <div style={{ width: "100%" }}>
                    <Form.Select as="select"                        
                        className={props.className ?? null}
                        disabled={props.disabled}
                        required={props.required}
                        name={props.id}
                        value={value} onChange={(e) => { if (props.onChange) { props.onChange(e.target.value) } updateVal(e.target.value) }}
                    >
                        {props.hideNone ?? <option key={'initial'} value={""}>{t("none")}</option>}
                        {
                            props.items?.map((key, idx) => (
                                
                                <option key={idx} value={props.itemId ? key[props.itemId] : idx}>{(props.itemLabelFn?.(key) ?? (props.itemLabel ? key[props.itemLabel] : key))}</option>
                            ))
                        }
                            </Form.Select>
                        </div>
                        {props.onCreateClick && <Button className="btn btn-secondary" onClick={() => props.onCreateClick?.()}><FontAwesomeIcon icon={solid("plus")} /></Button>}
                    </Stack>
            }

            {props.multiple && <Form.Control                
                style={{ display: "none" }}
                disabled={false}
                required={props.required}
                name={props.id}
                placeholder={props.placeholder || t("enterValue")}
                value={field} onChange={() => { }} />
            }

            <Form.Control.Feedback type="invalid" tooltip>
                {t('fieldRequired')}
            </Form.Control.Feedback>
            
        </Form.Group>
    );
};

export default observer(FormSelect);
